import { useLocation } from 'react-router-dom';
import { SUPPORT_ADMINISTRATION_ROUTE } from '../routes/Router';

const isSupportAdministrationRoute = () => {
    const { pathname } = useLocation();
    return pathname.replace(/\/$/, '') === SUPPORT_ADMINISTRATION_ROUTE;
};

export default isSupportAdministrationRoute;
